import RolesCreateEdit from './RolesCreateEdit';
import { connect } from 'react-redux';
import { createRole, editRole, fetchRole } from '../../../actions/role_actions';
import { bindActionCreators } from 'redux';
import { completeRequest } from '../../../actions/request_state';

function mapStateToProps(state) {
  return {
    role: state.role.role,
    permissions: state.permissions.permissionNames,
    isSubmitting: state.requestState.requestSaveRoleSend,
    FetchRoleAdminSend: state.requestState.requestSaveRoleSend,
    serverErrors: state.requestState.requestErrorsOnSaveRole
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createRole: bindActionCreators(createRole, dispatch),
    editRole: bindActionCreators(editRole, dispatch),
    completeRequest: bindActionCreators(completeRequest, dispatch),
    fetchRole: bindActionCreators(fetchRole, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RolesCreateEdit);
